const n = (t) => typeof t == "number" ? t : 368, o = (t, e) => {
  const r = e && n(e);
  return r && t > r ? r : t;
};
export {
  o as getDropdownMaxHeight
};
//# sourceMappingURL=Dropdown.helpers.es.js.map
